import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';

const StepStatistics = ({ statistics }) => {
  if (!statistics) return null;

  return (
    <Row className="mb-4">
      <Col md="3">
        <Card className="text-center border-0 bg-primary text-white">
          <CardBody className="p-3">
            <H5 className="mb-1">{statistics.totalSteps || 0}</H5>
            <small>Tổng Steps</small>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="text-center border-0 bg-success text-white">
          <CardBody className="p-3">
            <H5 className="mb-1">{statistics.activeSteps || 0}</H5>
            <small>Active Steps</small>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="text-center border-0 bg-info text-white">
          <CardBody className="p-3">
            <H5 className="mb-1">{statistics.byType?.quiz || 0}</H5>
            <small>Quiz Steps</small>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="text-center border-0 bg-warning text-white">
          <CardBody className="p-3">
            <H5 className="mb-1">{statistics.byType?.information || 0}</H5>
            <small>Info Steps</small>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default StepStatistics;

